import Showdown from 'showdown';

export const converter = new Showdown.Converter({
    tables: true,
    simplifiedAutoLink: true,
    excludeTrailingPunctuationFromURLs: true,
    // A link must not take the document it sits in away with what is unsaved
    // (R-261). Showdown adds rel="noopener noreferrer" with it.
    openLinksInNewWindow: true,
    strikethrough: true,
    disableForced4SpacesIndentedSublists: true,
    underline: true,
    simpleLineBreaks: true,
});
